import React from "react";
import "./UnityApp.css";
import {useSelector} from "react-redux";
import {AppState} from "../state/AppStore";

export interface UnityAppProps {
    path: string;
}

export const UnityApp = (props: UnityAppProps) => {
    const {baseUrl} = useSelector((state:AppState) => state.meta.settings);
    return (
        <div className="UnityApp">
            <iframe title={"Application"} src={`${baseUrl}${props.path}`}/>
        </div>
    )
};
